export default {
  name: 'light',
  colors: {
    background: '#FEFEFE',
    primary: '#2C2C2C',
    secondary: '#444444',
    button: '#0DA3B8',
    font: '#FFFFFF',
    title: '#000000',

  },
};
